import { Icon, Text } from '@pairy/pds-react';

import { PlanFeatureValue } from '../index.types';

interface Props {
  value: PlanFeatureValue;
  isHighlighted: boolean;
}

const FeatureCell = ({ value, isHighlighted }: Props) => {
  switch (value.kind) {
    case 'included':
      return (
        <Icon
          icon="ph:check-bold"
          size={17}
          color={isHighlighted ? 'skyblue_600' : 'viridian_500'}
          aria-label="제공"
        />
      );

    case 'partial':
      return (
        <Icon
          icon="ph:triangle"
          size={15}
          color={isHighlighted ? 'skyblue_600' : 'zinc_400'}
          aria-label="제한적 제공"
        />
      );

    case 'excluded':
      return (
        <Icon icon="ph:x-bold" size={17} color="zinc_300" aria-label="미제공" />
      );

    case 'notApplicable':
      return (
        <Text
          variant="md-regular"
          color="zinc_300"
          textAlign="center"
          aria-label="해당 없음"
        >
          -
        </Text>
      );

    case 'value':
      return (
        <Text
          variant="md-semibold"
          color={isHighlighted ? 'skyblue_600' : 'zinc_700'}
          textAlign="center"
        >
          {value.text}
        </Text>
      );
  }
};

export default FeatureCell;
